import styled from "styled-components";
import { palette } from "styled-theme";

const Wrapper = styled.div`
    .modalContent {
        font-size: 16px;
        padding: 30px 40px;
        color: ${palette("color", 21)};
        text-align: center;
    }
`;

export default Wrapper;